import { render } from "./ZoneWizardZoneDetailsStep.vue?vue&type=template&id=868d46ac&scoped=true"
import script from "./ZoneWizardZoneDetailsStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardZoneDetailsStep.vue?vue&type=script&lang=js"

import "./ZoneWizardZoneDetailsStep.vue?vue&type=style&index=0&id=868d46ac&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868d46ac"]])

export default __exports__